import { createMemoryHistory, createRouter } from "vue-router";
import Body from '../components/body';
import { saveCurrentRoute, getSavedRoute } from '../utils/urlHider';

/* Dashboards */
import Dashboard from '../pages/dashboard/dashboard';

import Products from '../pages/products/products.vue'
import AddProduct from '../pages/products/add_product.vue'
import EditProduct from '../pages/products/edit_product.vue'
import ProductStockLogs from '../pages/products/stock_logs.vue'
import SpeedGovernors from '../pages/products/speed_governor.vue'
import DealerCamera from '../pages/products/dealer_camera.vue'

import Technicians from '../pages/technicians/technicians.vue'
import AddTechnician from '../pages/technicians/add.vue'
import EditTechnician from '../pages/technicians/edit.vue'
import TechnicianDetails from '../pages/technicians/profile.vue'
import TechnicianJobs from '../pages/technicians/jobs.vue'
import TechnicianProducts from '../pages/technicians/products.vue'
import AddTechnicianProduct from '../pages/technicians/add_product.vue'
import TechnicianProductLogs from '../pages/technicians/stock_logs.vue'
import TechnicianLog from '../pages/technicians/technician_log.vue'

import Jobs from '../pages/jobs/job_list.vue'
import CreateJob from '../pages/jobs/create_job.vue'
import UpdateJob from '../pages/jobs/edit_job.vue'
import JobDetails from '../pages/jobs/job_details.vue'
import JobRequests from '../pages/jobs/job_requests.vue'
import EnquiryList from '../pages/jobs/enquiry_list.vue'
import EnquiryDetails from '../pages/jobs/enquiry_details.vue'
import CompanyTitles from '../pages/jobs/company_titles.vue'
import MarkComplete from '../pages/jobs/mark_complete.vue'
import JobLogs from '../pages/jobs/job_logs.vue'
import GenerateDeviceCertificate from '../pages/jobs/generate_device_certificate.vue'
import UpdateCertificate from '../pages/jobs/update_certificate.vue'

import ProductStockReport from '../pages/reports/product_stock.vue'
import WorkReport from '../pages/reports/work_report.vue'
import EarningsReport from '../pages/reports/earnings_report.vue'
import CancelRequests from '../pages/jobs/cancellation.vue'
import TechnicianReport from '../pages/reports/technician_report.vue'

import Staffs from '../pages/staffs/staffs.vue'
import StaffDetails from '../pages/staffs/details.vue'
import AddStaff from '../pages/staffs/add_staff.vue'
import UpdateStaff from '../pages/staffs/update_staff.vue'

import Settings from '../pages/settings/settings.vue'
import { getToken } from "@/utils/auth";
import store from '../store';

//Auth
import login from '../auth/login';
import Register from '../auth/register';

const routes = [
      {
        path: '/',
        component: Body,
    
        children: [
          {
            path: '',
            name: 'defaultRoot',
            component: Dashboard,
            meta: {
              title: ' Dashboard',
            }
          },

          {
            path: "products",
            name: "products",
            component: Products,
            meta: {
               title: "Products",
            },
          },
          {
            path: "add_product",
            name: "add_product",
            component: AddProduct,
            meta: {
               title: "Add Product",
            },
          },
          {
            path: "edit_product",
            name: "edit_product",
            component: EditProduct,
            meta: {
               title: "Edit Product",
            },
          },
          {
            path: "product_stock_logs",
            name: "product_stock_logs",
            component: ProductStockLogs,
            meta: {
               title: "Product Stock Logs",
            },
          },
          {
            path: "speed_governors",
            name: "speed_governors",
            component: SpeedGovernors,
            meta: {
               title: "Speed Governors",
            },
          },
          {
            path: "dealer_camera",
            name: "dealer_camera",
            component: DealerCamera,
            meta: {
               title: "Dealer Camera",
            },
          },
          {
            path: "technicians",
            name: "technicians",
            component: Technicians,
            meta: {
               title: "Technicians",
            },
          },
          {
            path: "add_technician",
            name: "add_technician",
            component: AddTechnician,
            meta: {
               title: "Add Technician",
            },
          },
          {
            path: "edit_technician",
            name: "edit_technician",
            component: EditTechnician,
            meta: {
               title: "Edit Technician",
            },
          },
          {
            path: "technician_details",
            name: "technician_details",
            component: TechnicianDetails,
            meta: {
               title: "Technician Details",
            },
          },
          {
            path: "technician_jobs",
            name: "technician_jobs",
            component: TechnicianJobs,
            meta: {
               title: "Technician Jobs",
            },
          },
          {
            path: "technician_products",
            name: "technician_products",
            component: TechnicianProducts,
            meta: {
               title: "Technician Products",
            },
          },
          {
            path: "add_technician_product",
            name: "add_technician_product",
            component: AddTechnicianProduct,
            meta: {
               title: "Add Technician Product",
            },
          },
          {
            path: "technician_product_logs",
            name: "technician_product_logs",
            component: TechnicianProductLogs,
            meta: {
               title: "Technician Product Logs",
            },
          },
          {
            path: "technician_travel_log",
            name: "technician_travel_log",
            component: TechnicianLog,
            meta: {
               title: "Technician Travel Logs",
            },
          },

          {
            path: "job_management",
            name: "job_management",
            component: Jobs,
            meta: {
               title: "Job Management",
            },
          },
          {
            path: "enquiry_list",
            name: "enquiry_list",
            component: EnquiryList,
            meta: {
               title: "Enquiry List",
            },
          },
          {
            path: "enquiry_details",
            name: "enquiry_details",
            component: EnquiryDetails,
            meta: {
               title: "Enquiry Details",
            },
          },
          {
            path: "create_job",
            name: "create_job",
            component: CreateJob,
            meta: {
               title: "Create Job",
            },
          },
          {
            path: "update_job",
            name: "update_job",
            component: UpdateJob,
            meta: {
               title: "Update Job",
            },
          },
          {
            path: "job_details",
            name: "job_details",
            component: JobDetails,
            meta: {
               title: "Job Details",
            },
          },
          {
            path: "mark_complete",
            name: "mark_complete",
            component: MarkComplete,
            meta: {
              title: "Mark As Completed",
            },
          },
          {
            path: "job_requests",
            name: "job_requests",
            component: JobRequests,
            meta: {
               title: "Job Requests",
            },
          },

          {
            path: "cancellation_requests",
            name: "cancellation_requests",
            component: CancelRequests,
            meta: {
               title: "Cancellation Requests",
            },
          },
          {
            path: "company_titles",
            name: "company_titles",
            component: CompanyTitles,
            meta: {
               title: "Company Titles",
            },
          },
          {
            path: "job_logs",
            name: "job_logs",
            component: JobLogs,
            meta: {
               title: "Job Logs",
            },
          },
          
          {
            path: "settings",
            name: "settings",
            component: Settings,
            meta: {
               title: "Settings",
            },
          },

          {
            path: "product_stock_report",
            name: "product_stock_report",
            component: ProductStockReport,
            meta: {
              title: "Product Stock Report",
            },
          },
          {
            path: "work_report",
            name: "work_report",
            component: WorkReport,
            meta: {
              title: "Work Report",
            },
          },
          {
            path: "earnings_report",
            name: "earnings_report",
            component: EarningsReport,
            meta: {
              title: "Earnings Report",
            },
          },
          {
            path: "technician_report",
            name: "technician_report",
            component: TechnicianReport,
            meta: {
              title: "Technician Report",
            },
          },

          {
            path: "staffs",
            name: "staffs",
            component: Staffs,
            meta: {
              title: "Staffs",
            },
          },
          {
            path: "staff_details",
            name: "staff_details",
            component: StaffDetails,
            meta: {
              title: "Staff Details",
            },
          },
          {
            path: "add_staff",
            name: "add_staff",
            component: AddStaff,
            meta: {
              title: "Add Staff",
            },
          },
          {
            path: "update_staff",
            name: "update_staff",
            component: UpdateStaff,
            meta: {
              title: "Update Staff",
            },
          },
          {
            path: "generate_device_certificate",
            name: "generate_device_certificate",
            component: GenerateDeviceCertificate,
            meta: {
              title: "Generate Device Certificate",
            },
          },
          {
            path: "update_certificate",
            name: "update_certificate",
            component: UpdateCertificate,
            meta: {
              title: "Update Certificate",
            },
          },
        ]
      },
      {
        path: '/',
        component: Body,
        children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            title: 'SPEED TECH Dashboard',
          }
        },
        ]
      },

      
      {
        path: '/',
        children: [
        {
          path: 'login',
          name: 'login',
          component: login,
          meta: {
            title: 'Login | SPEED TECH',
          }
        },
        {
          path: 'register',
          name: 'register 1',
          component: Register,
          meta: {
            title: 'Register | SPEED TECH',
          }
        }
        ]
      },
      
]
const router = createRouter({
  history: createMemoryHistory(),
  routes,
})

// Flag to track if this is the initial load
let isInitialLoad = true;

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  const authPaths = ['/login', '/register'];
  const isAuthRoute = authPaths.includes(to.path);
  const hasToken = getToken();

  if (isInitialLoad) {
    isInitialLoad = false;
    if (!hasToken) {
      if (isAuthRoute) return next();
      return next({ name: 'login' });
    }
    if (isAuthRoute) {
      return next();
    }
    try {
      await store.dispatch('user/ensureSettings');
    } catch {
      return next({ name: 'login' });
    }
    const savedRoute = getSavedRoute();
    let targetName = savedRoute && savedRoute.name ? savedRoute.name : 'defaultRoot';
    let targetParams = (savedRoute && savedRoute.params) || {};
    let targetQuery = (savedRoute && savedRoute.query) || {};
    const isAllowed = store.getters['user/isRouteAllowed'](targetName);
    if (!store.getters['user/isFullAccess'] && !isAllowed) {
      targetName = 'defaultRoot';
      targetParams = {};
      targetQuery = {};
    }
    saveCurrentRoute(targetName, targetParams, targetQuery);
    return next({
      name: targetName,
      params: targetParams,
      query: targetQuery,
    });
  }

  if (!hasToken) {
    if (isAuthRoute) return next();
    return next({ name: 'login' });
  }

  if (isAuthRoute) {
    saveCurrentRoute(to.name, to.params, to.query);
    return next();
  }

  try {
    await store.dispatch('user/ensureSettings');
  } catch {
    return next({ name: 'login' });
  }

  if (!store.getters['user/isFullAccess'] && !store.getters['user/isRouteAllowed'](to.name)) {
    saveCurrentRoute('defaultRoot', {}, {});
    return next({ name: 'defaultRoot', replace: true });
  }

  saveCurrentRoute(to.name, to.params, to.query);
  return next();
});

// Save route after successful navigation
router.afterEach((to) => {
  saveCurrentRoute(to.name, to.params, to.query);
});
export default router